<div class="container">
    <h1>404</h1>
    <p>Oops! The page you're looking for could not be found.</p>
    <p>Go back to <a (click)="backToLastLocation()" class="text-primary"> Previous Page</a>.</p>
</div>